var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _path16, _circle2, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApoioPortuario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m16 14.586 5.586-5.586h-11.172z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m16 17h-3.404l3.404 3.08z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m24 9.414-5.586 5.586h11.172z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m34.414 15h7.586v8a1 1 0 0 0 2 0v-8h1.586l-5.586-5.586z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m48 14.586 5.586-5.586h-11.172z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#00ad25",
    height: 3,
    rx: 1,
    width: 23,
    x: 2,
    y: 55
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m32 14.586 5.586-5.586h-11.172z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m55.559 9.855-5.145 5.145h7.585z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m11 51.747 4.51-4.08-4.51-4.081z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m16 49.92-3.404 3.08h3.404z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m11 5.8 4.131-3.62-3.092-.134a1 1 0 0 0 -1.044 1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m11 18.253v8.161l4.51-4.081z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m11 30.92v8.16l4.51-4.08z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m16 37.253-4.51 4.08 4.51 4.081z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m16 24.586-4.51 4.081 4.51 4.08z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#00ad25",
    cx: 49,
    cy: 48,
    r: 1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m35 37.28 5.735-1.912a7.2 7.2 0 0 1 4.531 0l5.734 1.911v-4.279h-16z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m46 31v-3h2a1 1 0 0 0 0-2h-10a1 1 0 0 0 0 2h2v3z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#00ad25",
    cx: 37,
    cy: 48,
    r: 1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m16 7v-2.923l-3.339 2.923z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m57.316 41.492-12.684-4.227a5.155 5.155 0 0 0 -3.263 0l-12.685 4.227a1 1 0 0 0 -.541 1.468l.28.468 12.03-4.016a8.061 8.061 0 0 1 2.531-.412h.016.016a8.061 8.061 0 0 1 2.531.409l12.03 4.016.28-.468a.991.991 0 0 0 .143-.511 1 1 0 0 0 -.684-.954z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m41.086 41.309-11.609 3.875 6.8 11.331a1.01 1.01 0 0 0 .859.485h4.864v-7a1 1 0 0 1 2 0v7h4.867a1.009 1.009 0 0 0 .859-.486l6.8-11.33-11.612-3.875a5.861 5.861 0 0 0 -.914-.224v4.915a1 1 0 0 1 -2 0v-4.915a5.861 5.861 0 0 0 -.914.224zm-4.086 9.691a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm12-6a3 3 0 1 1 -3 3 3 3 0 0 1 3-3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ad25",
    d: "m3 15h10.586l-5.922-5.922-1.471 3.922h-3.193a1 1 0 0 0 0 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApoioPortuario);
export default __webpack_public_path__ + "static/media/apoio_portuario.37d1286c723782b7cff5e8c2d3ef8191.svg";
export { ForwardRef as ReactComponent };